import { DataBean } from "../DataBean";

export class OfficeNew extends DataBean {



    public async deleteOffice(idOffice: any): Promise<any> {
        return this.getCustomService("OrangeBase", "void_deleteOffice_Number", [idOffice]);
    }


    public async getOfficeCatalogbypaginator(regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("OrangeBase", "com.advantage.shared.Report_getOfficeCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }

}